module.exports = __webpack_public_path__ + "img/aqtobe1.0a05f5ce.jpg";